export const videos = [
  {
    id: "video-01",
    title: "徐允儿 · 晚间新闻开场合集精选",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20Korean%20female%20news%20anchor%20opening%20evening%20news%20in%20studio%2C%20warm%20spotlights%2C%20modern%20tv%20set%2C%20editorial%20photography&width=640&height=360&seq=video-01&orientation=landscape",
    streamerId: "seo-yuna",
    streamerName: "徐允儿",
    type: "节目片段",
    duration: "12:48",
    views: "328万",
    date: "2026-10-15",
  },
  {
    id: "video-02",
    title: "林世拉 · 红毯独家采访幕后花絮",
    cover: "https://readdy.ai/api/search-image?query=Korean%20female%20host%20doing%20red%20carpet%20interview%20backstage%2C%20glamorous%20lights%2C%20modern%20venue%2C%20editorial%20photography&width=640&height=360&seq=video-02&orientation=landscape",
    streamerId: "im-sera",
    streamerName: "林世拉",
    type: "采访",
    duration: "08:32",
    views: "512万",
    date: "2026-10-15",
  },
  {
    id: "video-03",
    title: "韩诗雅 · 音乐银行舞台混剪",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20Korean%20music%20show%20stage%20with%20female%20host%20and%20glowing%20lights%2C%20modern%20stage%20set%2C%20editorial%20photography&width=640&height=360&seq=video-03&orientation=landscape",
    streamerId: "han-sia",
    streamerName: "韩诗雅",
    type: "节目片段",
    duration: "10:05",
    views: "446万",
    date: "2026-10-15",
  },
  {
    id: "video-04",
    title: "金荷娜 · 深夜脱口秀高能名场面",
    cover: "https://readdy.ai/api/search-image?query=cozy%20late%20night%20talk%20show%20set%20with%20Korean%20female%20host%20laughing%2C%20warm%20ambient%20lights%2C%20editorial%20photography&width=640&height=360&seq=video-04&orientation=landscape",
    streamerId: "kim-hana",
    streamerName: "金荷娜",
    type: "节目片段",
    duration: "15:21",
    views: "389万",
    date: "2026-10-13",
  },
  {
    id: "video-05",
    title: "白智雅 · 写真 MV 时尚大片",
    cover: "https://readdy.ai/api/search-image?query=chic%20fashion%20photoshoot%20with%20Korean%20female%20host%20in%20studio%2C%20warm%20soft%20lights%2C%20minimal%20editorial%20set%2C%20photography&width=640&height=360&seq=video-05&orientation=landscape",
    streamerId: "baek-jia",
    streamerName: "白智雅",
    type: "写真MV",
    duration: "06:14",
    views: "287万",
    date: "2026-10-14",
  },
  {
    id: "video-06",
    title: "郑多恩 · 综艺现场爆笑合集",
    cover: "https://readdy.ai/api/search-image?query=fun%20Korean%20variety%20show%20stage%20with%20female%20host%20laughing%2C%20colorful%20studio%20lights%2C%20editorial%20photography&width=640&height=360&seq=video-06&orientation=landscape",
    streamerId: "jung-daeun",
    streamerName: "郑多恩",
    type: "节目片段",
    duration: "18:47",
    views: "402万",
    date: "2026-10-14",
  },
  {
    id: "video-07",
    title: "吴世恩 · 明星直击专访实录",
    cover: "https://readdy.ai/api/search-image?query=Korean%20female%20reporter%20interviewing%20celebrities%20backstage%2C%20warm%20lights%2C%20modern%20venue%2C%20editorial%20photography&width=640&height=360&seq=video-07&orientation=landscape",
    streamerId: "oh-seeun",
    streamerName: "吴世恩",
    type: "采访",
    duration: "11:09",
    views: "198万",
    date: "2026-10-14",
  },
  {
    id: "video-08",
    title: "姜智秀 · 清晨新闻温暖日常精选",
    cover: "https://readdy.ai/api/search-image?query=bright%20morning%20news%20studio%20with%20Korean%20female%20anchor%20smiling%2C%20soft%20window%20light%2C%20minimal%20set%2C%20editorial%20photography&width=640&height=360&seq=video-08&orientation=landscape",
    streamerId: "kang-jisu",
    streamerName: "姜智秀",
    type: "节目片段",
    duration: "09:36",
    views: "167万",
    date: "2026-10-12",
  },
];